<section
  class="home-recent-changes"
  data-section-id="homeia_home_recent_changes"
  *ngIf="featureAvailable"
>
  <header class="hrc-header">
    <h3 class="hrc-title">{{ lang.translate('home.recentChanges.title') }}</h3>
    <a class="hrc-link" [routerLink]="changesLink">
      {{ lang.translate('home.recentChanges.viewAll') }}
    </a>
  </header>

  <ul
    class="hrc-list"
    *ngIf="!loading && !hasError && !isEmpty; else hrcState"
    [attr.aria-label]="lang.translate('home.recentChanges.title')"
  >
    <li class="hrc-item" *ngFor="let item of items; trackBy: trackById">
      <span
        class="hrc-severity"
        [class.hrc-severity--high]="item.severity === 'high'"
        [class.hrc-severity--critical]="item.severity === 'critical'"
      >{{ severityLabel(item) }}</span>
      <span class="hrc-date">{{ item.changedAt | date: 'mediumDate' }}</span>
      <p class="hrc-summary" [title]="item.summary">{{ item.summary }}</p>
    </li>
  </ul>

  <ng-template #hrcState>
    <div class="hrc-error" *ngIf="hasError; else hrcNonError" role="alert">
      <p class="hrc-error-title">{{ lang.translate('home.recentChanges.errorTitle') }}</p>
      <p class="hrc-error-message">{{ lang.translate('home.recentChanges.errorMessage') }}</p>
      <button type="button" class="btn btn-outline-primary" (click)="onRetry()">
        {{ lang.translate('home.general.retry') }}
      </button>
    </div>
    <ng-template #hrcNonError>
      <div class="hrc-empty" *ngIf="isEmpty; else hrcLoading">
        {{ lang.translate('home.recentChanges.empty') }}
      </div>
      <ng-template #hrcLoading>
        <div class="hrc-loading" role="status">{{ lang.translate('home.general.loading') }}</div>
      </ng-template>
    </ng-template>
  </ng-template>
</section>
